import React from 'react';
import { Check, X, ArrowRight, ChevronDown, UserPlus } from 'lucide-react';
import { Button } from '../../../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../ui/dropdown-menu';
import { STAGE_ORDER, stageLabel, nextStageOf } from './drawerShared';

const nodeClass = (state) => ({
  done: 'bg-emerald-600 border-emerald-600 text-white',
  current: 'bg-blue-600 border-blue-600 text-white ring-4 ring-blue-100',
  upcoming: 'bg-white border-slate-200 text-slate-400',
  rejected: 'bg-rose-600 border-rose-600 text-white ring-4 ring-rose-100',
}[state]);

export const StageStepper = ({ stage }) => {
  const rejected = stage === 'rejected';
  const idx = STAGE_ORDER.indexOf(stage);
  return (
    <ol className="flex w-full items-start" data-testid="stage-stepper">
      {STAGE_ORDER.map((s, i) => {
        const state = rejected ? (i === 0 ? 'rejected' : 'upcoming') : i < idx ? 'done' : i === idx ? 'current' : 'upcoming';
        const last = i === STAGE_ORDER.length - 1;
        return (
          <li key={s} className={`flex items-start ${last ? '' : 'flex-1'}`} data-testid={`stepper-${s}`} data-state={state}>
            <div className="flex flex-col items-center">
              <span className={`flex h-8 w-8 items-center justify-center rounded-full border-2 text-xs font-bold transition-colors ${nodeClass(state)}`}>
                {state === 'done' ? <Check className="h-4 w-4" /> : state === 'rejected' ? <X className="h-4 w-4" /> : i + 1}
              </span>
              <span className={`mt-1.5 whitespace-nowrap text-[11px] font-semibold ${state === 'current' ? 'text-blue-700' : state === 'done' ? 'text-emerald-700' : state === 'rejected' ? 'text-rose-700' : 'text-slate-400'}`}>
                {stageLabel(s)}
              </span>
            </div>
            {!last && <div className={`mx-2 mt-4 h-0.5 flex-1 rounded ${!rejected && i < idx ? 'bg-emerald-500' : 'bg-slate-200'}`} />}
          </li>
        );
      })}
    </ol>
  );
};

export const StageActions = ({ stage, canEdit, saving, onStageChange, canConvert, onConvert }) => {
  const next = nextStageOf(stage);
  const others = [...STAGE_ORDER].filter((s) => s !== stage);
  if (!canEdit) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="stage-actions">
      {next && (
        <Button size="sm" className="h-8 gap-1.5 bg-blue-600 text-xs font-semibold hover:bg-blue-700" disabled={saving} onClick={() => onStageChange(next)} data-testid="move-next-stage-btn">
          Move to {stageLabel(next)} <ArrowRight className="h-3.5 w-3.5" />
        </Button>
      )}
      {canConvert && (
        <Button size="sm" className="h-8 gap-1.5 bg-emerald-600 text-xs font-semibold hover:bg-emerald-700" onClick={onConvert} data-testid="recruitment-convert-btn">
          <UserPlus className="h-3.5 w-3.5" /> Convert to Employee
        </Button>
      )}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs" disabled={saving} data-testid="change-stage-btn">
            Change Stage <ChevronDown className="h-3.5 w-3.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-44">
          {others.map((s) => (
            <DropdownMenuItem key={s} onClick={() => onStageChange(s)} data-testid={`drawer-stage-${s}`}>{stageLabel(s)}</DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
